import styled from 'styled-components';

export const ContainerForm = styled.div`
  box-sizing: border-box;
  margin-top: 60px;
  margin-left: 340px;
  margin-right: 40px;
  padding: 20px;
  width: 100%;
  background-color: ${({ theme }) => {
    return theme.colors.backgroundForm;
  }};
  border: ${({ theme }) => {
    return theme.border;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};

  form {
    display: flex;
    flex-direction: column;
    font-size: ${({ theme }) => {
      return theme.fonts.size.big;
    }};

    label,
    input {
      margin-bottom: 5px;
    }
  }
`;

export const ContainerPages = styled.div`
  display: flex;
  height: 100vh;
  align-items: flex-start;
  position: relative;
  z-index: 5;
  background-color: ${({ theme }) => {
    return theme.colors.white;
  }};
`;

export const ContainerMenu = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: 80px 0 50px 350px;
`;

export const ContainerMenuButtons = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
`;

export const ContainerFormForStatusFooter = styled.div`
  box-sizing: border-box;
  padding: 20px;
  width: 97%;
  background-color: ${({ theme }) => {
    return theme.colors.backgroundForm;
  }};
  border: ${({ theme }) => {
    return theme.border;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};

  form {
    display: flex;
    flex-direction: column;
    font-size: ${({ theme }) => {
      return theme.fonts.size.big;
    }};

    label,
    input {
      margin-bottom: 5px;
    }
  }
`;
